
import * as signalR from "@microsoft/signalr";
import { appConfig } from "../../config";
import { urlFilter } from "../../utilities";

function createSignalR(url: string): signalR.HubConnection {
  const baseUrl: string = appConfig.chatUrl || ""
  return new signalR.HubConnectionBuilder().withUrl(urlFilter(baseUrl, url)).withAutomaticReconnect().build()
}

async function callSignalRMethod(connection: signalR.HubConnection, method: string,  ...args: any[]): Promise<void> {
  await connection.invoke(method, ...args)
}

function signalREventHandler(connection: signalR.HubConnection, method: string, callback: (...args: any[]) => any): void {
  connection.on(method, callback)
}

async function startSignalR(connection: signalR.HubConnection): Promise<void> {
  await connection.start();
}

async function stopSignalR(connection: signalR.HubConnection): Promise<void> {
  await connection.stop();
}

export {callSignalRMethod, createSignalR, signalREventHandler, startSignalR, stopSignalR}